import request from './api'

export class TeamsService {
    async getTeamStats(teamId: string) {
        const response = await request({
            method: 'GET',
            url: `api/teams/${teamId}/matchStats`
        });

        return response;
    }

    async getTeamNames() {
        const response = await request({
            method: 'GET',
            url: `api/teams/names`
        });

        return response;
    }

    async getTeamsList() {
        const response = await request({
            method: 'GET',
            url: `api/teams/list`
        });

        return response;
    }

    async getTeamsByAgeGradeCategory(ageGradeCategoryId: string) {
        const response = await request({
            method: 'GET',
            url: `api/teams/list?ageGradeCategoryId=${ageGradeCategoryId}`
        });

        return response;
    }

    async getTeamsByClub(clubId: string) {
        const response = await request({
            method: 'GET',
            url: `api/teams/${clubId}/list`
        });
        return response;
    }

    static get instance() { return teamsService }
}

const teamsService = new TeamsService();

export default teamsService;